import type { IntlShape } from 'react-intl';
import { getConvertedDistance } from '@alltrails/data-formatting/distanceConverters';

/**
 * Formats trail length for display in map pins.
 * - For values < 10: rounds to 10th (1 decimal place)
 * - For values >= 10: rounds to whole number
 *
 * @param intl - Intl object for localization
 * @param meters - Trail length in meters
 * @param metric - Whether to use km (true) or mi (false)
 * @returns Formatted string like "0.3 mi", "19 km", "234 mi", "1,234 km"
 */
export const formatTrailLengthForPin = (intl: IntlShape, meters: number, metric: boolean): string => {
  const rawDistance = getConvertedDistance(meters, metric);
  const unit = metric ? 'kilometer' : 'mile';

  const roundedToTenth = Math.round(rawDistance * 10) / 10;
  const useWholeNumber = roundedToTenth >= 10;
  const maximumFractionDigits = useWholeNumber ? 0 : 1;
  const minimumFractionDigits = useWholeNumber ? 0 : 1;

  return intl.formatNumber(rawDistance, {
    style: 'unit',
    unit,
    minimumFractionDigits,
    maximumFractionDigits,
    // Use short unit display (mi, km) rather than long (miles, kilometers)
    unitDisplay: 'short'
  });
};
